import React, { useRef, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import "./styles/adrTentativeAgreement.css";
import AlertBox from "../_common/AlertBox";

export function AdrTentativeAgreementModal_MaterialsV3(props) {
  const {
    projectId,
    status,
    isLocked,
    selectedLocations,
    materialsView,
    updateMaterial,
    changeJustificationModal,
  } = props;
  const projLocationList = useSelector(
    (state) => state.locations.projLocationLists[projectId] || null
  );

  return (
    <React.Fragment>
      <div className="d-flex flex-column w-100 ta-wp">
        {Object.keys(selectedLocations).length ? (
          Object.keys(materialsView).length > 0 ? (
            Object.entries(materialsView).map(([locId, tams], groupIndex) => {
              const location = (projLocationList || []).find(
                (l) => l.locationId === +locId
              );
              const locName = location ? location.name : "(N/A)";
              return (
                <div key={`tamLocGroupKey_${locId}_${groupIndex}`} className="card m-1">
                  <div className="card-body p-2 bg-lightgray">
                    <h6 className="text-muted">Location: {locName}</h6>
                    <div className="d-flex flex-column w-100">
                      {tams.map((tam) => (
                        <AdrTentativeAgreementModal_MaterialsRowV3
                          key={`tamItemKey_${tam.key}`}
                          projectId={projectId}
                          status={status}
                          isLocked={isLocked}
                          locationId={locId}
                          taMaterial={tam}
                          updateMaterial={updateMaterial}
                          changeJustificationModal={changeJustificationModal}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="ta-wp__tr">
              <div className="ta-wp__td">
                <input
                  name="noLaborsToShow"
                  id="noLaborsToShow"
                  className="form-control"
                  value={"There are no materials selected for this TA."}
                  onChange={() => {}}
                  disabled={true}
                />
              </div>
            </div>
          )
        ) : (
          <div className="w-100 p-1">
            <AlertBox icon="exclamation-triangle" color="warning">
              Select location(s) above to view misc. materials.
            </AlertBox>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

function AdrTentativeAgreementModal_MaterialsRowV3(props) {
  const {
    projectId,
    status,
    isLocked,
    taMaterial,
    locationId,
    updateMaterial,
    changeJustificationModal,
  } = props;

  const unitsOfMeasure = useSelector(
    (state) => state.feederLists.miscMaterialsUnitsOfMeasure || null
  );

  const [showChangeJustificationModal, _toggleChangeJustificationModal] = useState(false);
  const toggleChangeJustificationModal = () =>
    _toggleChangeJustificationModal(!showChangeJustificationModal);

  const cachedValues = useRef({
    excludeFromTa: taMaterial.excludeFromTa,
  });
  const changeAnnotation = useRef("");

  const getUnitOfMeasure = (mmuId) => {
    const mmu = unitsOfMeasure
      ? unitsOfMeasure.find((uom) => uom.miscMaterialsUnitOfMeasureId === mmuId) || null
      : null;
    return mmu ? mmu.unitOfMeasure : "";
  };

  const cancelChange = () => {
    updateMaterial(locationId, taMaterial.key, {
      excludeFromTa: cachedValues.current.excludeFromTa,
    });
  };

  const updateCachedValues = () => {
    cachedValues.current = {
      excludeFromTa: taMaterial.excludeFromTa,
    };
  };

  const handleChange_excludeFromTa = (e) => {
    updateMaterial(locationId, taMaterial.key, {
      excludeFromTa: !e.target.checked,
    });
    if (isLocked) {
      const actionLabel = e.target.checked ? "Added" : "Removed";
      changeAnnotation.current = `${actionLabel} ${
        taMaterial.description
      }, (with quantity of ${+taMaterial.quantity || "0"} ${getUnitOfMeasure(
        taMaterial.miscMaterialsUnitOfMeasureId
      )}) from this TA.`;
      toggleChangeJustificationModal();
    }
  };

  return (
    <React.Fragment>
      <div className="card m-0">
        <div className="card-body p-1">
          <div className="d-flex flex-row w-100">
            <div className="ta-wp__td--matl-info">
              {taMaterial.locationId < -1 && (
                <div className="row">
                  <div className="col-lg-3 col-sm-4 pr-1">
                    <b>Mat'l At:</b>
                  </div>
                  <div className="col-lg-9 col-sm-8 pl-1">
                    <span className="text-muted">
                      <b>{taMaterial.locationName}</b>
                    </span>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-lg-3 col-sm-4 pr-1">
                  <b>Description:</b>
                </div>
                <div className="col-lg-9 col-sm-8 pl-1">
                  {taMaterial.description || "(N/A)"}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-sm-4 pr-1">
                  <b>Vendor:</b>
                </div>
                <div className="col-lg-9 col-sm-8 pl-1">
                  {taMaterial.vendorName || "(N/A)"}
                </div>
              </div>
              <div className="row pr-1">
                <div className="col-lg-3 col-sm-4">
                  <b>Invoice No:</b>
                </div>
                <div className="col-lg-9 col-sm-8 pl-1">
                  {taMaterial.invoiceNo || "(N/A)"}
                </div>
              </div>
              <div className="row pr-1">
                <div className="col-lg-3 col-sm-4">
                  <b>Quantity:</b>
                </div>
                <div className="col-lg-9 col-sm-8 pl-1">
                  {`${taMaterial.quantity || "0"} ${getUnitOfMeasure(
                    taMaterial.miscMaterialsUnitOfMeasureId
                  )}`}
                </div>
              </div>
            </div>
            <div className="ta-wp__td--matl-select">
              <div className="ta-wp__checkbox">
                <label
                  className="form-label ml-2"
                  htmlFor={`taMaterialSelect_${taMaterial.key}`}
                >
                  <b>TA Work?</b>
                </label>
                <input
                  type="checkbox"
                  name="includeInTa"
                  className="align-middle py-auto ml-2"
                  id={`taMaterialSelect_${taMaterial.key}`}
                  style={{ width: "2.2rem", height: "2.2rem" }}
                  value={!taMaterial.excludeFromTa}
                  checked={!taMaterial.excludeFromTa}
                  onTouchEnd={handleChange_excludeFromTa}
                  onChange={handleChange_excludeFromTa}
                  disabled={status.isReadOnly}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showChangeJustificationModal &&
        changeJustificationModal({
          locationId,
          key: taMaterial.key,
          showModal: showChangeJustificationModal,
          toggleModal: toggleChangeJustificationModal,
          changeAnnotation: changeAnnotation.current,
          cancelChange,
          updateCachedValues,
        })}
    </React.Fragment>
  );
}
